import React from 'react';
import { Flex, Menu, Tooltip } from '@mantine/core';

interface TableActionMenuProps {
  data: any;
  addText?: string;
  viewText?: string;
  deleteText?: string;
  editText?: string;
  approvedText?: string;
  rejectedText?: string;
  downloadText?: string;
  handleAdd?: (data: any) => void;
  handleView?: (data: any) => void;
  handleEdit?: (data: any) => void;
  handleDelete?: (data: any) => void;
  handleApproved?: (data: any) => void;
  handleRejected?: (data: any) => void;
  handleDownload?: (data: any) => void;
  handleCustomAction?: (data: any) => React.ReactNode;
}

const TableActionMenu: React.FC<TableActionMenuProps> = ({
  handleAdd,
  handleDelete,
  handleEdit,
  handleView,
  handleApproved,
  handleRejected,
  handleDownload,
  handleCustomAction,
  addText,
  viewText,
  deleteText,
  editText,
  approvedText,
  rejectedText,
  downloadText,
  data,
}) => {
  return (
    <Menu shadow="md">
      <Flex gap={4}>
        {handleView && (
          <Tooltip label={viewText}>
            <Flex
              justify={'center'}
              c={'blue'}
              style={{ cursor: 'pointer' }}
              align={'center'}
              onClick={() => handleView(data)}
              p={4}
            >
              <i className="fa fa-eye"></i>
            </Flex>
          </Tooltip>
        )}
        {handleDownload && (
          <Tooltip label={downloadText}>
            <Flex
              justify={'center'}
              c={'blue'}
              style={{ cursor: 'pointer' }}
              align={'center'}
              onClick={() => handleDownload(data)}
              p={4}
            >
              <i className="fa fa-download"></i>
            </Flex>
          </Tooltip>
        )}
        {
          handleAdd && (
            <Tooltip label={addText}>
              <Flex
                justify={'center'}
                c={'blue'}
                style={{ cursor: 'pointer' }}
                align={'center'}
                onClick={() => handleAdd(data)}
                p={4}
              >
                <i className='fa fa-plus'></i>
              </Flex>
            </Tooltip>
          )
        }
        {handleEdit && (
          <Tooltip label={editText}>
            <Flex
              justify={'center'}
              c={'blue'}
              style={{ cursor: 'pointer' }}
              align={'center'}
              onClick={() => handleEdit(data)}
              p={4}
            >
              <i className="fa fa-pencil"></i>
            </Flex>
          </Tooltip>
        )}
        {handleDelete && (
          <Tooltip label={deleteText}>
            <Flex
              justify={'center'}
              c={'blue'}
              style={{ cursor: 'pointer' }}
              align={'center'}
              onClick={() => handleDelete(data)}
              p={4}
            >
              <i className="fa fa-trash"></i>
            </Flex>
          </Tooltip>
        )}
        {handleApproved && (
          <Tooltip label={approvedText}>
            <Flex
              justify={'center'}
              c={'blue'}
              style={{ cursor: 'pointer' }}
              align={'center'}
              onClick={() => handleApproved(data)}
              p={4}
            >
              <i className="fa fa-check"></i>
            </Flex>
          </Tooltip>
        )}
        {handleRejected && (
          <Tooltip label={rejectedText}>
            <Flex
              justify={'center'}
              c={'red'}
              style={{ cursor: 'pointer' }}
              align={'center'}
              onClick={() => handleRejected(data)}
              p={4}
            >
              <i className="fa fa-xing"></i>
            </Flex>
          </Tooltip>
        )}
        {handleCustomAction && handleCustomAction(data)}
      </Flex>
    </Menu>
  );
};

export default TableActionMenu;
